import { MailInfo } from './../../model/mail-info.model';
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ErrorFeedbackComponent } from '../../modal/error-feedback/error-feedback.component';
import { MatchingOffer } from './../../model/matching-offer.model';

@Component({
  selector: 'app-error-feed-back-button',
  templateUrl: './error-feed-back-button.component.html',
  styleUrls: ['./error-feed-back-button.component.scss']
})
export class ErrorFeedBackButtonComponent implements OnInit {
  @Input() mailInfo: MailInfo;
  @Input() mailType: string;
  @Input() page: string;
  @Input() matchingScoreId: number;
  @Output() deleted = new EventEmitter<any>();
  @Output() correctMail = new EventEmitter<any>();
  @Input() offers: MatchingOffer[]; // 共通アカウント（USER_CODE）に紐付くオファーを取得
  @Input() offeredMailIds: number[]; // offersの中のmail_id

  constructor(
    private modalService: NgbModal
  ) {}

  ngOnInit() {}

  errorFeedback() {
    const modalRef = this.modalService.open(ErrorFeedbackComponent);
    modalRef.componentInstance.mailInfo = this.mailInfo;
    modalRef.componentInstance.mailType = this.mailType;
    modalRef.componentInstance.page = this.page;
    modalRef.componentInstance.matchingScoreId = this.matchingScoreId;

    modalRef.result.then(
      res => {
        if (res.status === 200) {
          this.deleted.emit(res);
        }
      },
      reason => {
        return false; // いいえ や x でダイアログを閉じたらこっち
      }
    );
  }

  correctMailInfo(): void {
    this.correctMail.emit(this.mailInfo.ai_mail_id);
  }

  // 削除ボタンの活性化・非活性化を判定
  // メールが既に提案管理に登録されている場合はtrue
  isAlreadyOffered(): Boolean {
    var result = this.mailInfo.is_mail_already_offered
    return result
  }
  // メールが案件人材管理から登録されたものの場合はtrue
  isRegisteredMail(): Boolean {
    var result = this.mailInfo.mail_register_id != null
    return result
  }
}
